"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var skynet_store_utilities_1 = require("@synisys/skynet-store-utilities");
var layout_utils_1 = require("../../utils/layout-utils");
var ControllerModel = /** @class */ (function () {
    function ControllerModel(id, controllerMeta, _isNew, columnCount, bindings, actions, state, fields, visibility, title) {
        this._isNew = _isNew;
        this.visibility = visibility;
        this.title = title;
        this.id = id;
        this.state = state || {};
        this.bindings = bindings || {};
        this.actions = actions || controllerMeta.defaultActions;
        this.meta = controllerMeta;
        this.columnCount = columnCount
            ? columnCount
            : controllerMeta.columnCount;
        this.isConfigurable = !!controllerMeta.settings;
        this.fields = fields || {};
        this.calculateSingleFieldMultilingualDisplayName();
    }
    Object.defineProperty(ControllerModel.prototype, "isNew", {
        get: function () {
            return this._isNew;
        },
        enumerable: true,
        configurable: true
    });
    ControllerModel.fieldKeyIfSingle = function (fields) {
        return Object.keys(fields).length === 1 ? Object.keys(fields)[0] : null;
    };
    ControllerModel.extractFieldIfSingle = function (fields, extractor) {
        var key = ControllerModel.fieldKeyIfSingle(fields);
        return key && fields[key] ? extractor(fields[key]) : null;
    };
    ControllerModel.prototype.addSingleField = function (field) {
        this.fields['field'] = field;
    };
    ControllerModel.prototype.addSingleFieldMultilingualDisplayName = function (displayName) {
        this.singleFieldMultilingualDisplayName = displayName;
    };
    ControllerModel.prototype.addMapFields = function (fields) {
        this.fields = __assign({}, fields);
        this.calculateSingleFieldMultilingualDisplayName();
    };
    ControllerModel.prototype.addFields = function (fields) {
        this.fields = fields;
        this.calculateSingleFieldMultilingualDisplayName();
    };
    ControllerModel.prototype.fieldIsMultiLineAndSingle = function () {
        return ControllerModel.extractFieldIfSingle(this.fields, function (field) { return field['isMultiline']; });
    };
    ControllerModel.prototype.fieldSystemNameIfSingle = function () {
        return ControllerModel.extractFieldIfSingle(this.fields, function (field) { return field['metaFieldId'].systemName; });
    };
    ControllerModel.prototype.fieldMessageIdIfSingle = function () {
        return ControllerModel.extractFieldIfSingle(this.fields, function (field) { return field['displayNameMsgId']; });
    };
    ControllerModel.prototype.fieldCompoundCategoryIfSingle = function () {
        return ControllerModel.extractFieldIfSingle(this.fields, function (field) { return field['compoundCategorySystemName']; });
    };
    ControllerModel.prototype.fieldMaxLengthIfSingle = function () {
        return ControllerModel.extractFieldIfSingle(this.fields, function (field) { return field['maxLength']; });
    };
    ControllerModel.prototype.fieldsSize = function () {
        return Object.keys(this.fields).length;
    };
    ControllerModel.prototype.calculateSingleFieldMultilingualDisplayName = function () {
        if (skynet_store_utilities_1.notNil(this.fields)) {
            this.singleFieldMultilingualDisplayName = ControllerModel.extractFieldIfSingle(this.fields, function (field) {
                return field['displayNameMultilingual']
                    ? layout_utils_1.LayoutUtils.multiLingualToJson(field['displayNameMultilingual'])
                    : undefined;
            });
        }
    };
    return ControllerModel;
}());
exports.ControllerModel = ControllerModel;
//# sourceMappingURL=controller.model.js.map